export default (props) => {
    return Object.keys(props).reduce((prev, key) => {
        if (key.substr(0, 5) === 'aria-' ||
            key.substr(0, 5) === 'data-' ||
            key === 'role') {
            prev[key] = props[key];
        }
        return prev;
    }, {});
};



// WEBPACK FOOTER //
// ./components/_util/getDataAttr.tsx